<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout py-2 wrap justify-center px-2>
      <v-flex xs12 sm12 md8 text-left>
        <span style="font-size:22px;font-weight:600">Trending</span>
      </v-flex>
    </v-layout>
    <v-layout py-2 wrap justify-center>
      <v-flex xs12 sm12 md5 text-left px-2 pb-2>
        <v-layout wrap>
          <v-flex>
            <span style="font-size:22px;font-weight:600">Blog</span>
          </v-flex>
        </v-layout>
        <div v-for="(item,i) in trendingImage" :key="i">
          <v-layout wrap py-2>
            <v-flex xs12 sm4 md4 px-2>
              <v-img height="120px" :src="baseURL+'/u/'+item.image" contain>
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-flex>
            <v-flex xs12 sm8 md8 px-2>
              <router-link :to="'/Blog/'+item._id">
                <v-layout wrap>
                  <v-flex>
                    <span style="font-size:14px;font-weight:500;color:#000">{{item.title}}</span>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex text-left style="line-height:1" text-justify>
                    <span
                      style="font-size:12px;font-weight:400;color:#000"
                    >{{item.shortDescription.substring(0, 150) + "..."}}</span>
                  </v-flex>
                </v-layout>
              </router-link>
              <v-layout pt-2>
                <v-flex text-left style="line-height:1">
                  <span style="font-size:12px;font-weight:500;color:#000;">{{item.author}}</span>
                  <br />
                  <span
                    style="font-size:12px;font-weight:400;color:#000"
                  >{{formatDate(item.createddate)}}</span>
                </v-flex>
                <v-flex text-right align-center>
                  <span style="font-size:10px">
                    <v-icon
                      :color="item.isBookMarked ? '#1fb07c' :'#a9a9a9'"
                      @click="bookmark(item,i)"
                    >mdi-bookmark-outline</v-icon>
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </div>
      </v-flex>
      <v-flex xs12 sm12 md3 text-left px-2>
        <v-layout wrap>
          <v-flex>
            <span style="font-size:22px;font-weight:600">Videos</span>
          </v-flex>
        </v-layout>
        <div v-for="(item,i) in trendingVideo" :key="i">
          <v-layout wrap>
            <v-flex text-left px-2 xs12 sm4 md12>
              <v-img height="120px" :src="baseURL+'/u/'+item.thumbnail" contain>
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-flex>
            <v-flex xs12 sm8 md12>
              <router-link :to="'/Blog/'+item._id">
                <v-layout wrap px-2>
                  <v-flex xs12 sm12 md12>
                    <span style="font-size:14px;font-weight:500;color:#000">{{item.title}}</span>
                  </v-flex>
                  <v-flex style="line-height:1" text-justify xs12 sm12 md12>
                    <span
                      style="font-size:12px;font-weight:400;color:#000"
                    >{{item.shortDescription.substring(0, 150) + "..."}}</span>
                  </v-flex>
                </v-layout>
              </router-link>
              <v-layout pt-1 wrap>
                <v-flex text-left style="line-height:1" px-2>
                  <span style="font-size:12px;font-weight:400;">{{item.author}}</span>
                  <br />
                  <span style="font-size:12px;font-weight:400;">{{formatDate(item.createddate)}}</span>
                </v-flex>
                <v-flex text-right align-center px-2>
                  <span style="font-size:10px">
                    <v-icon
                      :color="item.isBookMarked ? '#1fb07c' :'#a9a9a9'"
                      @click="bookmark(item,i)"
                    >mdi-bookmark-outline</v-icon>
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <v-layout py-2 wrap justify-center>
      <v-flex xs12 sm12 md8>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["blogData"],
  data() {
    return {
      trendingImage: [],
      trendingVideo: [],
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      ServerError: false
    };
  },
  mounted() {
    this.trendingImage = this.blogData.trendingimage;
    this.trendingVideo = this.blogData.trendingvideo;
  },
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;

      // this.trendingVideo.createddate = strTime;
      return strTime;
    },
    bookmark(item, index) {
      console.log(index);
      if (localStorage.getItem("token")) {
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/blog/bookmark",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          data: {
            id: item._id,
            status: !item.isBookMarked
          }
        })
          .then(response => {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            if (item.type == "Normal Blog") {
              this.trendingImage[index].isBookMarked = !this.trendingImage[
                index
              ].isBookMarked;
            }
            if (item.type == "Video Blog") {
              this.trendingVideo[index].isBookMarked = !this.trendingVideo[
                index
              ].isBookMarked;
            }
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.msg = "Please login to bookmark";
        this.showsnackbar = true;
      }
    }
  }
};
</script>